// based on: https://redux-toolkit.js.org/rtk-query/usage/mutations#advanced-mutations-with-revalidation
// see parcel issue about these imports: https://github.com/parcel-bundler/parcel/issues/7622#issuecomment-1028378916
import { createApi } from '@reduxjs/toolkit/query/react';
import { fetchBaseQuery } from '@reduxjs/toolkit/query';

export const baseApi = createApi({
    reducerPath: 'baseApi',
    baseQuery: fetchBaseQuery({
        baseUrl: '/api/',
    }),
    tagTypes: [],
    endpoints: (builder) => ({
        // will be provided by external files (see adjacent api files)
    }),
})